import * as symbolMarks from './symbol.json';
import * as labelMarks from './label.json';
import * as valueMarks from './value.json';

export default [].concat(
  symbolMarks, labelMarks, valueMarks
);



// WEBPACK FOOTER //
// ./src/app/hsd-tree/sum-tree/vega-spec/marks/tree/single-nodes/index.ts